"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportItemSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var TextArea_1 = __importDefault(require("antd/lib/input/TextArea"));
var collectionsRef_1 = require("common/db/collectionsRef");
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var app_1 = __importDefault(require("firebase/app"));
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var Yup = __importStar(require("yup"));
exports.ImportItemSchema = Yup.object().shape({
    serialNumber: Yup.string().required(),
    notes: Yup.string().required(),
});
function AddNewMaintenanceItemDialog(props) {
    var _this = this;
    var _a;
    var modalState = props.modalState, setModalState = props.setModalState;
    var t = (0, react_i18next_1.useTranslation)().t;
    var warehouseItems = (0, firestore_1.useCollection)(collectionsRef_1.warehouseItemsRef.where("cachedProductType", "==", "asset"))[0];
    var warehouseItemsData = (_a = warehouseItems === null || warehouseItems === void 0 ? void 0 : warehouseItems.docs) === null || _a === void 0 ? void 0 : _a.map(function (item) {
        var data = item.data();
        return __assign(__assign({}, data), { id: item.id });
    });
    var formProps = (0, formik_1.useFormik)({
        initialValues: {
            serialNumber: "",
            notes: "",
        },
        validationSchema: exports.ImportItemSchema,
        onSubmit: function (values, form) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                app_1.default.firestore().runTransaction(function (transaction) { return __awaiter(_this, void 0, void 0, function () {
                    var warehousesFilteredToSerialNumbers;
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                    return __generator(this, function (_p) {
                        try {
                            warehousesFilteredToSerialNumbers = warehouseItemsData.filter(function (item) { return formProps.values.serialNumber === item.serialNumbers[0]; });
                            if (warehousesFilteredToSerialNumbers) {
                                antd_1.message.error(t("alerts.noAssetFoundWithEnteredSerialNumber"));
                            }
                            transaction.set(collectionsRef_1.warehouseMaintenanceItemsRef.doc(), (0, removeUndefined_1.default)({
                                stockNumber: (_a = warehousesFilteredToSerialNumbers[0]) === null || _a === void 0 ? void 0 : _a.stockNumber,
                                productId: (_b = warehousesFilteredToSerialNumbers[0]) === null || _b === void 0 ? void 0 : _b.productId,
                                cachedProductName: (_c = warehousesFilteredToSerialNumbers[0]) === null || _c === void 0 ? void 0 : _c.cachedProductName,
                                cachedProductUnit: (_d = warehousesFilteredToSerialNumbers[0]) === null || _d === void 0 ? void 0 : _d.cachedProductUnit,
                                cachedProductCategory: (_e = warehousesFilteredToSerialNumbers[0]) === null || _e === void 0 ? void 0 : _e.cachedProductCategory,
                                storageLocation: (_f = warehousesFilteredToSerialNumbers[0]) === null || _f === void 0 ? void 0 : _f.storageLocation,
                                cachedProductDescription: (_g = warehousesFilteredToSerialNumbers[0]) === null || _g === void 0 ? void 0 : _g.cachedProductDescription,
                                projectId: (_h = warehousesFilteredToSerialNumbers[0]) === null || _h === void 0 ? void 0 : _h.projectId,
                                budgetLineId: (_j = warehousesFilteredToSerialNumbers[0]) === null || _j === void 0 ? void 0 : _j.budgetLineId,
                                maintenanceNotes: (_k = values.notes) !== null && _k !== void 0 ? _k : "",
                                createdAt: new Date(),
                                updatedAt: new Date(),
                                warehouseId: (_l = warehousesFilteredToSerialNumbers[0]) === null || _l === void 0 ? void 0 : _l.warehouseId,
                                serialNumber: values.serialNumber,
                                assetsNumbers: (_m = warehousesFilteredToSerialNumbers[0]) === null || _m === void 0 ? void 0 : _m.assetsNumbers,
                                status: "In maintenance",
                            }));
                            // if (sameProducts) {
                            transaction.update(collectionsRef_1.warehouseItemsRef.doc((_o = warehousesFilteredToSerialNumbers[0]) === null || _o === void 0 ? void 0 : _o.id), {
                                status: "In maintenance",
                            });
                            // serialNumbers: [...sameProducts.serialNumbers, ...serialNumbers],
                            // assetsNumbers: [...sameProducts.assetsNumbers, ...assetsNumbers],
                            //     })
                            // } else {
                            //     transaction.set(
                            //         warehouseItemsRef.doc(),
                            //         removeUndefined({
                            //             warehouseId: values.warehouseId,
                            //             productId: values.productId,
                            //             cachedProductName: product.name,
                            //             cachedProductUnit: product.unitId,
                            //             cachedProductDescription: product.description,
                            //             cachedProductType: product.productType,
                            //             quantity: quantity,
                            //             projectId: values.projectId,
                            //             budgetLineId: values.budgetLineId,
                            //             createdAt: new Date() as any,
                            //             updatedAt: new Date() as any,
                            //             serialNumbers: serialNumbers,
                            //             assetsNumbers: assetsNumbers,
                            //             batchNumber: values.batchNumber?.trim(),
                            //             cachedProductCategory: product.categoryId,
                            //             cachedProductUnitName: globalUnitsData[product.unitId]?.name,
                            //             cachedProductUnitPerPrescriptionQuantity: globalUnitsData[product.unitId]?.perPrescriptionQuantity,
                            //             stockNumber: values.stockNumber,
                            //             storageLocation: values.storageLocation,
                            //         } as WarehouseItem)
                            //     )
                            // }
                            antd_1.message.success(t("alerts.success"));
                            setModalState(undefined);
                            form.resetForm();
                        }
                        catch (e) {
                            console.log(e);
                            antd_1.message.error(t("alerts.error"));
                        }
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        }); },
    });
    return ((0, jsx_runtime_1.jsx)(antd_1.Modal, __assign({ title: "Add new maintenance item", open: modalState, onOk: formProps.submitForm, onCancel: function () { return setModalState(undefined); }, confirmLoading: formProps.isSubmitting }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({ labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("serialNumber").touched) &&
                        formProps.errors.serialNumber &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("serialNumber").touched) &&
                        formProps.errors.serialNumber, label: t("warehouse.serialNumber") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { type: "text", value: formProps.values.serialNumber, onChange: formProps.handleChange("serialNumber") }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes, label: t("common.notes") }, { children: (0, jsx_runtime_1.jsx)(TextArea_1.default, { value: formProps.values.notes, onChange: formProps.handleChange("notes") }) }))] })) })));
}
exports.default = AddNewMaintenanceItemDialog;
